.row {
    display: flex;
    min-height: 32px;
    /* Match shells/draggable-row `.show-overflow`: removable field badge sits outside the row box */
    overflow: visible;
    width: 100%;
    box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.15);
}

.drag-handle {
    width: 21px;
    display: flex;
    flex-shrink: 0;
    align-items: center;
    padding-left: 7px;
    color: var(--grey-lt);
    flex-grow: 0;
    background-color: var(--off-white-dk);
    cursor: grab;
}

.drag-handle:hover,
.drag-handle:focus {
    color: var(--grey-dk);
}

.drag-handle > :first-child {
    height: 14px;
}

.content-hovered {
    display: flex;
    align-items: center;
    flex-grow: 1;
    background-color: var(--off-white);
    overflow: visible;
    padding-left: 1px;
}

.content {
    margin-left: 29px;
}
